/**
 * 检查指定 URL 的脚本是否已加载
 * @param url - 脚本的 URL 地址
 * @returns 如果脚本已存在返回 true，否则返回 false
 */
function isScriptLoaded(url: string): boolean {
    const scripts = document.getElementsByTagName('script');
    const normalizedUrl = new URL(url, window.location.href).href;

    for (let i = 0; i < scripts.length; i++) {
        const scriptSrc = scripts[i].src;
        if (scriptSrc === normalizedUrl || scriptSrc.startsWith(normalizedUrl + '?')) {
            return true;
        }
    }
    return false;
}

/**
 * 动态加载外部脚本
 * @param url - 脚本的 URL 地址
 * @param withTimestamp - 是否在 URL 后添加时间戳以避免缓存
 * @param allowDuplicate - 是否允许重复加载相同的 URL，默认为 false
 * @returns Promise，加载成功则 resolve，加载失败则 reject
 */
export function loadScript(url: string, withTimestamp = false, allowDuplicate = false) {
    if (!allowDuplicate && isScriptLoaded(url)) {
        return Promise.resolve();
    }
    if (withTimestamp) {
        url = `${url}?t=${Date.now()}`;
    }
    return new Promise(function(resolve, reject) {
        // Adding the script tag to the head as suggested before
        const head = document.getElementsByTagName('head')[0];
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.async = true;
        script.charset = 'UTF-8';

        script.onload = resolve;
        script.onerror = reject;

        // Fire the loading
        head.appendChild(script);
    });
}
